import { inject, Injectable } from '@angular/core';
import { Key } from 'src/app/types/shared';
import { AppDB, KINTERF, SYSINI, SYSOOPT } from './dexieDB';
import { AsMappedTableFE } from './sharedDB';
import { extractKeys } from 'src/app/misc/functions';

@Injectable({ providedIn: 'root' })
export class EinstellungenDB {
  private readonly db = inject(AppDB);

  async GetINIOptions() {
    const einstellungen = await this.db.sysini.toArray();
    return AsMappedTableFE()(einstellungen, ['optFk1_IstGleich_BG', 'optDownChangeFK', 'optMINNumFK', 'optMAXNumFK']);
  }

  async GetOption<K extends Key<SYSINI>>(option: K): Promise<SYSINI[K]> {
    const sysini = await this.db.sysini.get(1);
    return sysini[option];
  }
  async GetOptions<K extends Key<SYSINI>>(...options: K[]): Promise<Pick<SYSINI, K>> {
    const sysini = await this.db.sysini.get(1);
    return extractKeys(sysini, options);
  }

  async GetTypOption<K extends Key<SYSOOPT>>(OTYPID: number, option: K): Promise<SYSOOPT[K]> {
    const sysoopt = await this.db.sysoopt.where({ OTYPID }).first();
    return sysoopt[option];
  }
  async GetTypOptions<K extends Key<SYSOOPT>>(OTYPID: number, ...options: K[]): Promise<Pick<SYSOOPT, K>> {
    const sysoopt = await this.db.sysoopt.where({ OTYPID }).first();
    return extractKeys(sysoopt, options);
  }

  async GetInterfaceOption<K extends Key<KINTERF>>(option: K): Promise<KINTERF[K]> {
    const kinterf = await this.db.kinterf.get(1);
    return kinterf[option];
  }

  async GetInterfaceOptions<K extends Key<KINTERF>>(...options: K[]): Promise<Pick<KINTERF, K>> {
    const kinterf = await this.db.kinterf.get(1);
    return extractKeys(kinterf, options);
  }

  async GetFKColors() {
    const { optMINNumFK: minFK, optFKColors: colorsJoined } = await this.GetOptions('optMINNumFK', 'optFKColors');
    const colors = [...(colorsJoined?.split(';') ?? DEFAULT_FK_COLORS)]; // immer [0 - 10]
    if (minFK == 1) colors[0] = '#FFFFFF00'; // transparent
    return colors;
  }
}

const DEFAULT_FK_COLORS = [
  '#8B0000',
  '#FF0000',
  '#FFFF00',
  '#008000',
  '#0000FF',
  '#800080',
  '#FFA500',
  '#FFC0CB',
  '#808080',
  '#FF8C00',
  '#008080',
];
